/* Studio Mottos V17: sync native Shop Pay installments to the selected actual Shopify variant. */
(() => {
  if (window.__smPaymentTermsV17) return;
  window.__smPaymentTermsV17 = true;
  const slots = new WeakMap();
  const sectionFor = node => node?.closest?.('[id^="shopify-section-"]') || node?.closest?.('.shopify-section');
  function actualVariant(section) {
    const form = section?.querySelector('form[action*="/cart/add"]:not([id*="payment-installment"])');
    return form?.querySelector('[name="id"]')?.value || null;
  }
  function update(section, variantId) {
    if (!section || !variantId) return;
    section.querySelectorAll('payment-terms').forEach(wrapper => {
      wrapper.querySelectorAll('form input[name="id"], form select[name="id"]').forEach(input => {
        if (String(input.value) !== String(variantId)) {
          input.value = String(variantId);
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      // Shopify's official payment-terms element uses the variant-id attribute.
      wrapper.querySelectorAll('shopify-payment-terms').forEach(element => {
        if (element.getAttribute('variant-id') !== String(variantId)) {
          element.setAttribute('variant-id', String(variantId));
        }
      });
    });
  }
  function arrange(section) {
    if (!section) return;
    const reviews = section.querySelector('.product-info__block-item[data-block-type="sm-reviews-mobile"]');
    const terms = section.querySelector('.product-info__block-item[data-block-type="payment-terms"]');
    if (!reviews || !terms || !reviews.parentElement || reviews.parentElement !== terms.parentElement) return;
    if (!slots.has(reviews)) {
      const marker = document.createComment('Original mobile reviews position');
      reviews.parentNode.insertBefore(marker, reviews);
      slots.set(reviews, marker);
    }
    if (window.matchMedia('(max-width: 999px)').matches) {
      if (terms.nextElementSibling !== reviews) terms.after(reviews);
    } else {
      const marker = slots.get(reviews);
      if (marker?.parentNode) marker.after(reviews);
    }
  }
  function init(root = document) {
    const sections = new Set();
    root.querySelectorAll?.('payment-terms').forEach(el => {const section=sectionFor(el);if(section)sections.add(section);});
    if (root.matches?.('[id^="shopify-section-"]')) sections.add(root);
    sections.forEach(section => { update(section, actualVariant(section)); arrange(section); });
  }
  document.addEventListener('sm:variant-change', e => {
    const section = sectionFor(e.target);
    update(section, e.detail?.variant?.id || actualVariant(section));
  });
  document.addEventListener('variant:change', e => {
    const section = sectionFor(e.target);
    update(section, e.detail?.variant?.id || actualVariant(section));
  });
  document.addEventListener('change', e => {
    if (!e.target.matches?.('form[action*="/cart/add"] [name="id"]')) return;
    const section = sectionFor(e.target);
    if (!e.target.closest('payment-terms')) update(section, e.target.value);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  window.addEventListener('resize', () => document.querySelectorAll('payment-terms').forEach(el => arrange(sectionFor(el))), {passive:true});
})();
